import { Device } from "../constants/device.js";
import { Service } from "./Service.js";

export class DeviceService extends Service {
  #value;

  get os() {
    if (!this.#value) {
      const userAgent = navigator.userAgent;
      if (/android/i.test(userAgent)) {
        this.#value = Device.ANDROID;
      } else if (/iPad|iPhone|iPod/.test(userAgent)) {
        this.#value = Device.IOS;
      } else {
        this.#value = Device.DESKTOP;
      }
    }
    return this.#value;
  }

  get mobile() {
    return this.os === Device.ANDROID || this.os === Device.IOS;
  }

  get ios() {
    return this.os === Device.IOS;
  }

  get android() {
    return this.os === Device.ANDROID;
  }
}
